import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { checkPermissionByRoles } from "./utils/checkPermission";
import { getNextAvailableTab } from "./utils/getNextAvailableTab";
import { ToastContainer } from "react-toastify";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AccountSettings from "./pages/AccountSettings";
import ActiveProviders from "./outlets/ActiveProviders";
import ActiveUsers from "./outlets/ActiveUsers";
import AddAppointments from "./outlets/AddAppointments";
import AddBusiness from "./outlets/AddBusiness";
import AddInsurance from "./outlets/AddInsurance";
import ViewInsurance from "./outlets/ViewInsurance";
import ViewStateInsurances from "./outlets/ViewStateInsurances";
import AddForYouCategory from "./outlets/AddForYouCategory";
import AddForYouVideO from "./outlets/AddForYouVideo";
import AddFutureSelfQuestionnairs from "./outlets/AddFutureSelfQuestionnaire";
import AddJourneyForm from "./outlets/AddJourneyForm";
import AddMember from "./outlets/AddMember";
import AddMembership from "./outlets/AddMembership";
import AddSolutionCoaches from "./outlets/AddSolutionCoaches";
import AddTag from "./outlets/AddTag";
import AdminContent from "./outlets/AdminContent";
import Appointments from "./pages/Appointments";
import ArchiveUsers from "./outlets/ArchiveUsers";
import AuditLogs from "./components/AuditLogs";
import BusinessDetails from "./pages/BusinessDetails";
import Businesses from "./pages/Businesses";
import CancelledAppointments from "./outlets/CancelledAppointments";
import ChangePassword from "./pages/changePassword";
import ChangeRequest from "./pages/ChangeRequest";
import ClientDetail from "./outlets/ClientDetail";
import Clients from "./outlets/Clients";
import ClosedSupportRequest from "./outlets/ClosedSupportRequest";
import CompletedAppointments from "./outlets/CompletedAppointments";
import ConnectRequest from "./pages/ConnectRequest";
import Content from "./pages/Content";
import CreateBlog from "./outlets/CreateBlog";
import Dashboard from "./pages/Dashboard";
import DayVideoSelector from "./outlets/assignVideos";
import EditAppointment from "./outlets/EditAppointment";
import EditExerciseComponent from "./outlets/EditExerciseComponent";
import FCMHandler from "./firebase/FCMHandler";
import socketService from "./services/socketService";
import ForgotPassword from "./pages/ForgotPassword";
import ForYouCategory from "./outlets/ForYouCategory";
import ForYouCategoryDetailView from "./outlets/ForYouCategoryDetailView";
import ForYouVideo from "./outlets/ForYouVideo";
import ForYouVideoDetailView from "./outlets/ForYouVideoDetailView";
import FutureSelfDetailView from "./outlets/FutureSelfDetailView";
import FutureSelfListview from "./outlets/FutureSelfListview";
import Header from "./components/Header";
import HealthWellness from "./outlets/HealthWellness";
import InactiveProviders from "./outlets/InactiveProviders";
import JourneyExercisesView from "./outlets/JourneyExercisesView";
import JourneysManagement from "./outlets/JourneysManagement";
import Login from "./pages/Login";
import logo from "./assets/Numente.png";
import Logout from "./pages/Logout";
import Memberships from "./pages/Memberships";
import NoShowAppointments from "./outlets/NoShowAppointments";
import NotificationForm from "./pages/NotificationForm";
import OpenSupportRequests from "./outlets/OpenSupportRequest";
import Prompts from "./outlets/SolutionCoach";
import ProviderAvailabilityPage from "./components/ProviderAvailabilityPage";
import ProviderContent from "./outlets/ProviderContent";
import ProviderDetails from "./components/ProviderDetails";
import ProviderProfile from "./components/ProviderProfile";
import ProviderRegistration from "./components/ProviderRegistration/ProviderRegistration";
import Providers from "./pages/Providers";
import PayerMatrix from "./pages/PayerMatrix";
import Reports from "./pages/Reports";
import SessionHistory from "./pages/SessionHistory";
import ProfileInformationOnboarding from "./pages/onboarding/ProfileInformationOnboarding";
import LicensesCredentialsOnboarding from "./pages/onboarding/LicensesCredentialsOnboarding";
import PaymentsAcceptedOnboarding from "./pages/onboarding/PaymentsAcceptedOnboarding";
import AvailabilityOnboarding from "./pages/onboarding/AvailabilityOnboarding";
import SettingsOnboarding from "./pages/onboarding/SettingsOnboarding";
import {
  isIncompleteAllowedPath,
  isIncompleteTherapist,
  needsProviderOnboarding,
} from "./utils/providerOnboarding";
import SessionHistoryAdmin from "./pages/SessionHistoryAdmin";
import SessionHistoryDetailView from "./outlets/SessionHistoryDetailView";
import FollowUp from "./outlets/FollowUp";
import Sidebar from "./components/Sidebar";
import SolutionCoach from "./outlets/SolutionCoaches";
import SolutionCoachesDetailView from "./outlets/SolutionCoachesDetailView";
import SupportRequestDetail from "./outlets/SupportRequestDetail";
import SupportRequestDetails from "./outlets/SupportRequestDetails";
import SupportRequests from "./pages/SupportRequest";
import SupportRequestsManagement from "./outlets/SupportRequestsManagement";
import Tags from "./outlets/TagsListView";
import TagsDetailView from "./outlets/TagsDetailView";
import TeamMember from "./pages/TeamMember";
import TeamMemberProfileDetails from "./components/TeamMemberProfileDetails";
import UpcomingAppointments from "./outlets/UpcomingAppointments";
import UpdatePasswordBusiness from "./pages/UpdatePasswordBusiness";
import UserProfile from "./components/UserDetails";
import Users from "./pages/Users";
import UsersEmail from "./outlets/UsersEmail";
import UpcomingSessions from "./pages/UpcomingSessions";
import VideoCallPage from "./pages/VideoCallPage";
import WaitingRoomPage from "./pages/WaitingRoomPage";
import SessionBillingDetails from "./pages/SessionBillingDetails";
import RegistryCoCM from "./pages/RegistryCoCM";
import ClinicDetail from "./pages/ClinicDetail";
import AddNewPatient from "./pages/AddNewPatient";
import PatientInfo from "./pages/PatientInfo";
import MyPatients from "./pages/MyPateints";
import ActivityCoCM from "./pages/ActivityCoCM";
import Messages from "./pages/Messages";
import InitialAssessmentPage, { FollowUpPage } from "./pages/InitialAssessmentPage";

const Layout = ({ isAuth, user }) => {
  const authRoutes = ["/", "/forgot-password", "/login", "/update-password"];

  const location = useLocation();

  const isAuthRoute = authRoutes.includes(location.pathname);
  const isStandaloneSessionRoute =
    location.pathname === "/video-call" ||
    location.pathname === "/waiting-room";

  // Initialize Socket.IO connection when user is authenticated
  useEffect(() => {
    if (isAuth && !isAuthRoute) {
      socketService.connect();
    } else {
      socketService.disconnect();
    }

    return () => {
      // Cleanup on unmount
      if (!isAuth || isAuthRoute) {
        socketService.disconnect();
      }
    };
  }, [isAuth, isAuthRoute]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <div className="main-bg-color flex-grow-1">
        {isAuth && !isAuthRoute && !isStandaloneSessionRoute && (
          <div className="main-header">
            <div className="logo-box">
              <a href="/">
                <img alt="Numente Logo" src={logo} />
              </a>
            </div>

            <div className="user-box">
              <Header />
            </div>
          </div>
        )}

        <div className="d-flex app-shell">
          {isAuth && !isAuthRoute && !isStandaloneSessionRoute && (
            <>
              {(needsProviderOnboarding(user) ||
                !user?.is_first_login ||
                user?.role === "business") &&
                location.pathname !== "/session-details" &&
                location.pathname !== "/follow-up" && <Sidebar />}

              <Logout />
            </>
          )}

          <div className="container-fluid app-main">
            <Routes>
              <Route element={<AddJourneyForm />} path="/journeys/add" />
              <Route element={<AddTag />} path="/tags/add" />
              <Route
                element={<EditExerciseComponent />}
                path="/future-self-questionnaire/edit"
              />
              <Route element={<ForgotPassword />} path="/forgot-password" />
              <Route
                element={<ForYouCategoryDetailView />}
                path="/for-you-category/:id"
              />
              <Route
                element={<ForYouVideoDetailView />}
                path="/for-you-video/:id"
              />
              <Route
                element={<FutureSelfDetailView />}
                path="/future-self-questionnaire/:id"
              />
              <Route element={<JourneyExercisesView />} path="/journeys/:id" />
              <Route element={<Login />} path="/login" />
              <Route element={<Logout />} path="/logout" />
              <Route
                element={
                  <PrivateRoute isAuth={isAuth}>
                    <AddForYouCategory />
                  </PrivateRoute>
                }
                path="/for-you-category/add"
              />
              <Route
                element={
                  <PrivateRoute isAuth={isAuth}>
                    <AddForYouVideO />
                  </PrivateRoute>
                }
                path="/for-you-video/add"
              />
              <Route
                element={
                  <PrivateRoute isAuth={isAuth}>
                    <AddFutureSelfQuestionnairs />
                  </PrivateRoute>
                }
                path="/future-self-questionnaire/add"
              />
              <Route
                element={
                  <PrivateRoute isAuth={isAuth}>
                    <AddSolutionCoaches />
                  </PrivateRoute>
                }
                path="/solution-coach/add-solution-coaches"
              />
              <Route
                element={
                  <PrivateRoute isAuth={isAuth}>
                    <ChangePassword />
                  </PrivateRoute>
                }
                path="/change-password"
              />
              <Route
                element={
                  <ProviderRegisterationRoute isAuth={isAuth} user={user}>
                    <ProviderRegistration />
                  </ProviderRegisterationRoute>
                }
                path="/provider-registration"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AccountSettings />
                  </ProviderRoute>
                }
                path="/account-settings"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AccountSettings />
                  </ProviderRoute>
                }
                path="/account-settings"
              ></Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AddBusiness />
                  </ProviderRoute>
                }
                path="/businesses/addbusiness"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AddMember />
                  </ProviderRoute>
                }
                path="/add-member"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AddMembership />
                  </ProviderRoute>
                }
                path="/membership/:id"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AddMembership />
                  </ProviderRoute>
                }
                path="/membership/addmembership"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Appointments />
                  </ProviderRoute>
                }
                path="/appointments"
              >
                <Route element={<AddAppointments />} path="addAppointment" />
                <Route element={<CancelledAppointments />} path="cancelled" />
                <Route element={<CompletedAppointments />} path="completed" />
                <Route element={<EditAppointment />} path="editAppointment" />
                <Route element={<NoShowAppointments />} path="no-show" />
                <Route element={<UpcomingAppointments />} index />
                <Route element={<UpcomingAppointments />} path="upcoming" />
              </Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AuditLogs />
                  </ProviderRoute>
                }
                path="/audit-logs"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <BusinessDetails />
                  </ProviderRoute>
                }
                path="businesses/:id"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Businesses />
                  </ProviderRoute>
                }
                path="/businesses"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ChangeRequest />
                  </ProviderRoute>
                }
                path="/change-request"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ClientDetail />
                  </ProviderRoute>
                }
                path="/clients/:id"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Clients />
                  </ProviderRoute>
                }
                path="/clients"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ConnectRequest />
                  </ProviderRoute>
                }
                path="/connect-request"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Content />
                  </ProviderRoute>
                }
                path="/content"
              >
                <Route element={<AdminContent />} path="admin" />
                <Route element={<HealthWellness />} index />
                <Route element={<HealthWellness />} path="health-wellness" />
                <Route element={<ProviderContent />} path="provider" />
                <Route element={<UsersEmail />} path="user-email" />
              </Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <CreateBlog />
                  </ProviderRoute>
                }
                path="/content/createblog"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Dashboard />
                  </ProviderRoute>
                }
                path="/dashboard"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <DayVideoSelector />
                  </ProviderRoute>
                }
                path="/video-rotation"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ForYouCategory />
                  </ProviderRoute>
                }
                path="/for-you-category"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ForYouVideo />
                  </ProviderRoute>
                }
                path="/for-you-video"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <FutureSelfListview />
                  </ProviderRoute>
                }
                path="/future-self-questionnaire"
              ></Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <JourneysManagement />
                  </ProviderRoute>
                }
                path="/journeys"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Memberships />
                  </ProviderRoute>
                }
                path="/membership"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <NotificationForm />
                  </ProviderRoute>
                }
                path="/notification-form"
              ></Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Prompts />
                  </ProviderRoute>
                }
                path="/prompts"
              ></Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ProfileInformationOnboarding />
                  </ProviderRoute>
                }
                path="/onboarding/profile-information"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <LicensesCredentialsOnboarding />
                  </ProviderRoute>
                }
                path="/onboarding/licenses-credentials"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <PaymentsAcceptedOnboarding />
                  </ProviderRoute>
                }
                path="/onboarding/payments-accepted"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AvailabilityOnboarding />
                  </ProviderRoute>
                }
                path="/onboarding/availability"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <SettingsOnboarding />
                  </ProviderRoute>
                }
                path="/onboarding/settings"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ProviderAvailabilityPage />
                  </ProviderRoute>
                }
                path="/my-availability"
              ></Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ProviderProfile />
                  </ProviderRoute>
                }
                path="/profile"
              ></Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Providers />
                  </ProviderRoute>
                }
                path="/providers"
              >
                <Route element={<ActiveProviders />} index />
                <Route element={<ActiveProviders />} path="active" />
                <Route
                  element={
                    <Navigate
                      to="/providers"
                      replace
                      state={{ openAddDrawer: true }}
                    />
                  }
                  path="addprovider"
                />
                <Route element={<InactiveProviders />} path="inactive" />
                <Route element={<ProviderDetails />} path=":id" />
              </Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Reports />
                  </ProviderRoute>
                }
                path="/reports"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <SessionHistory />
                  </ProviderRoute>
                }
                path="/session-history"
              />
              <Route
                element={
                  <PrivateRoute isAuth={isAuth}>
                    <SessionHistoryAdmin />
                  </PrivateRoute>
                }
                path="/admin/session-history"
              />
              <Route
                element={
                  <PrivateRoute isAuth={isAuth}>
                    <SessionBillingDetails />
                  </PrivateRoute>
                }
                path="/admin/session-billings"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <SessionHistoryDetailView />
                  </ProviderRoute>
                }
                path="/session-details"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <FollowUp />
                  </ProviderRoute>
                }
                path="/follow-up"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <SolutionCoach />
                  </ProviderRoute>
                }
                path="/solution-coach"
              ></Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <SupportRequests />
                  </ProviderRoute>
                }
                path="/support-requests"
              >
                <Route element={<ClosedSupportRequest />} path="closed" />
                <Route element={<OpenSupportRequests />} index />
                <Route element={<OpenSupportRequests />} path="open" />
                <Route element={<SupportRequestDetails />} path="details" />
              </Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <SupportRequestsManagement />
                  </ProviderRoute>
                }
                path="/support-request"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Tags />
                  </ProviderRoute>
                }
                path="/tags"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <TeamMember />
                  </ProviderRoute>
                }
                path="/team-member"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <TeamMemberProfileDetails />
                  </ProviderRoute>
                }
                path="/team-member/:id"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Users />
                  </ProviderRoute>
                }
                path="/users"
              >
                <Route element={<ActiveUsers />} index />
                <Route element={<ActiveUsers />} path="active" />
                <Route element={<ArchiveUsers />} path="archive" />
                <Route element={<UserProfile />} path="/users/:id" />
              </Route>
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <RegistryCoCM />
                  </ProviderRoute>
                }
                path="/registry-cocm"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ClinicDetail />
                  </ProviderRoute>
                }
                path="/clinic-detail/:id"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ActivityCoCM />
                  </ProviderRoute>
                }
                path="/activity-cocm"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <Messages />
                  </ProviderRoute>
                }
                path="/messages"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <InitialAssessmentPage />
                  </ProviderRoute>
                }
                path="/activity-cocm/initial-assessment"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <FollowUpPage />
                  </ProviderRoute>
                }
                path="/activity-cocm/follow-up"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <MyPatients />
                  </ProviderRoute>
                }
                path="/careManager/my-patients"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <MyPatients />
                  </ProviderRoute>
                }
                path="/psychiatricConsultant/my-patients"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AddNewPatient />
                  </ProviderRoute>
                }
                path="/add-patient"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <PatientInfo />
                  </ProviderRoute>
                }
                path="/patient-info/:id"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <UpcomingSessions />
                  </ProviderRoute>
                }
                path="/upcoming-sessions"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <PayerMatrix />
                  </ProviderRoute>
                }
                path="/payer-matrix"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <AddInsurance />
                  </ProviderRoute>
                }
                path="/payer-matrix/add-insurance"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ViewInsurance />
                  </ProviderRoute>
                }
                path="/payer-matrix/insurance/:id"
              />
              <Route
                element={
                  <ProviderRoute isAuth={isAuth} user={user}>
                    <ViewStateInsurances />
                  </ProviderRoute>
                }
                path="/payer-matrix/state/:id/insurances"
              />
              <Route
                element={
                  <RedirectToDashboardOrLogin isAuth={isAuth} user={user} />
                }
                path="/"
              />
              <Route
                element={<SolutionCoachesDetailView />}
                path="/solution-coach/:id"
              />
              <Route
                element={<SupportRequestDetail />}
                path="/support-request/:id"
              />
              <Route element={<TagsDetailView />} path="/tags/:id" />
              <Route
                element={
                  user?.is_first_login ? (
                    <UpdatePasswordBusiness />
                  ) : (
                    <Navigate to="/dashboard" />
                  )
                }
                path="/update-password"
              />
              <Route element={<VideoCallPage />} path="/video-call" />
              <Route
                element={
                  <PrivateRoute isAuth={isAuth}>
                    <WaitingRoomPage />
                  </PrivateRoute>
                }
                path="/waiting-room"
              />
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};

const PrivateRoute = ({ children, isAuth }) =>
  isAuth ? children : <Navigate replace={true} to="/login" />;

const ProviderRoute = ({ children, isAuth, user }) => {
  if (!isAuth) return <Navigate replace={true} to="/login" />;

  if (isIncompleteTherapist(user)) {
    if (isIncompleteAllowedPath(window.location.pathname)) {
      return children;
    }
    return <Navigate replace={true} to="/dashboard" />;
  }

  return children;
};

const ProviderRegisterationRoute = ({ children, isAuth, user }) => {
  if (!isAuth) return <Navigate replace={true} to="/login" />;

  const isBypassRole =
    user?.role === "careManager" ||
    user?.role === "psychiatricConsultant" ||
    user?.providerType === "Care Manager" ||
    user?.providerType === "Psychiatric Consultant";

  if (user?.role !== "provider" && !isBypassRole && isAuth)
    return <Navigate replace={true} to="/login" />;

  // Incomplete therapists use the onboarding dashboard instead of the wizard.
  if (isIncompleteTherapist(user)) {
    return <Navigate replace={true} to="/dashboard" />;
  }

  return children;
};
const RedirectToDashboardOrLogin = ({ isAuth, user }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [nextTab, setNextTab] = useState(null);

  useEffect(() => {
    if (user?.role === "teamMember") {
      const tab = getNextAvailableTab(user, checkPermissionByRoles);

      setNextTab(tab);
    }

    setIsLoading(false);
  }, [user]);

  if (!isLoading) {
    let activeRoute = "dashboard";

    const isBypassRole =
      user?.role === "careManager" ||
      user?.role === "psychiatricConsultant" ||
      user?.providerType === "Care Manager" ||
      user?.providerType === "Psychiatric Consultant";

      if (user?.role === "provider" && !isBypassRole) {
      if (
        user?.providerStatus === "Incomplete" ||
        user?.providerStatus === "Invited"
      )
        activeRoute = "dashboard";
      else if (
        user?.providerStatus === "Active" ||
        user?.providerStatus === "Pending" ||
        user?.providerStatus === "Pending Review"
      )
        activeRoute = "dashboard";
      else activeRoute = "dashboard";
    } else if (
      user?.role === "careManager" ||
      user?.providerType === "Care Manager"
    ) {
      activeRoute = "dashboard";
    } else if (isBypassRole) {
      activeRoute = "appointments";
    } else if (user?.role === "teamMember") {
      activeRoute = nextTab ? nextTab : "dashboard";
    } else {
      activeRoute = "dashboard";
    }

    return isAuth ? (
      <Navigate replace={true} to={`/${activeRoute}`} />
    ) : (
      <Navigate replace={true} to="/login" />
    );
  }
};

function App() {
  const user = useSelector((state) => state?.user);

  const isAuth = user.user?.token ? true : false;

  return (
    <>
      {user?.user?.role === "provider" && <FCMHandler />}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ zIndex: 10050 }}
      />

      <Router>
        <Layout isAuth={isAuth} user={user.user} />
      </Router>
    </>
  );
}

export default App;
